<template>
  <div>
    <BaseSelect
      v-model="currentValue"
      class="!my-0 w-full"
      size="md"
      required
      :label="label"
      :name="name"
      :options="options"
      :active="filterActive"
      disableAutoSelect
      @change="selectValue"
    />
  </div>
</template>

<script>
import { isEqual } from "lodash";

export const LOCAL_STORAGE_FILTER_KEY = "FGU_TABLE_FILTER";

export default {
  props: {
    name: String,
    options: { type: Array, required: true },
    persist: { type: Boolean, default: true },
    label: { type: String, required: false },
  },

  emits: ["change"],

  data() {
    return {
      currentValue: null,
      persistedValue: null,
      selectedValue: null,
    };
  },

  computed: {
    filterActive() {
      if (!this.options.length || !this.currentValue) return false;

      return this.currentValue !== this.options[0].value;
    },

    localStorageKey() {
      return `${window.location.pathname}_${this.name}`;
    },
  },

  watch: {
    options: {
      handler(newOptions, oldOptions) {
        if (!isEqual(newOptions, oldOptions)) {
          this.setInitialValue();
        }
      },
    },
  },

  mounted() {
    this.persistedValue = this.getPersistedFilterValue();
    this.setInitialValue();
  },

  methods: {
    setInitialValue() {
      const preferredValue = this.selectedValue || (this.persist ? this.persistedValue : null);

      if (preferredValue && this.options.some((option) => option.value === preferredValue)) {
        this.changeValue(preferredValue);
      } else if (this.options.length > 0) {
        this.changeValue(this.options[0].value);
      }
    },

    // Applying a filter can narrow the option list itself, where the options are
    // derived from the rows being filtered. Remembering the pick keeps the
    // re-initialisation that follows from undoing it.
    selectValue(eventValue) {
      this.selectedValue = eventValue || "all";
      this.changeValue(eventValue);
    },

    changeValue(eventValue) {
      const value = eventValue || "all";

      this.currentValue = value;
      this.persistFilterValue(value);
      this.$emit("change", value);
    },

    persistFilterValue(value) {
      const object = this.getPersistedObject();
      object[this.localStorageKey] = String(value);

      localStorage.setItem(LOCAL_STORAGE_FILTER_KEY, JSON.stringify(object));
    },

    getPersistedFilterValue() {
      const object = this.getPersistedObject();
      return String(object[this.localStorageKey]) || "";
    },

    getPersistedObject() {
      return JSON.parse(localStorage.getItem(LOCAL_STORAGE_FILTER_KEY)) || {};
    },
  },
};
</script>
